import styled from "styled-components";
import {Select} from "antd";

const MOBILE_BREAKPOINT = "768px";

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 16px;
    margin-top: -50px;

    .desktop-only {
        @media (max-width: ${MOBILE_BREAKPOINT}) {
            display: none !important;
        }
    }
`;

export const TopSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media (max-width: 480px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

export const TopRightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
`;

export const CompanyInfo = styled.div`
    display: flex;
    align-items: center;
    font-weight: bold;
    gap: 12px;
    position: relative;
`;

export const BottomSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    min-height: 42px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
    }
`;

export const LeftSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    flex: 1;
    flex-wrap: wrap;
    min-height: 42px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
        order: 1;
        flex-wrap: nowrap;
    }
`;

export const RightSection = styled.div`
    display: flex;
    align-items: center;
    min-height: ${props => (props.$codOrAccounting ? "150px" : "48px")};
    width: 400px;
    flex-shrink: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        min-width: auto;
        width: 100%;
        justify-content: center;
        order: 2;
    }
`;

export const MenuButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 14px;
    border: none;
    border-radius: 8px;
    background-color: ${props => {
        if (props.$isActive) return "#AEF001";
        if (props.$isLogout) return "#fff";
        return "#fff";
    }};
    color: ${props => {
        if (props.$isActive) return "#000";
        if (props.$isLogout) return "#ff4d4f";
        return "#333";
    }};
    font-size: 14px;
    font-weight: ${props => (props.$isActive ? "600" : "500")};
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid ${props => (props.$isActive ? "#AEF001" : "#f0f0f0")};
    width: 140px;
    height: 42px;
    flex-shrink: 0;

    &:hover {
        background-color: ${props => {
            if (props.$isActive) return "#AEF001";
            if (props.$isLogout) return "#ffe7e7";
            return "#f8f8f8";
        }};
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        min-width: auto;
        justify-content: flex-start;
    }

    ${props =>
        props.$isMobile &&
        `
        width: 100%;
        min-width: auto;
        justify-content: flex-start;
        margin-bottom: 8px;
    `}
`;

export const ButtonIcon = styled.img`
    width: 14px;
    height: 14px;
`;

export const MobileMenuToggle = styled.button`
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 30px;
    height: 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: flex;
    }

    span {
        width: 25px;
        height: 3px;
        background: #333;
        border-radius: 10px;
        transition: all 0.3s linear;
        position: relative;
        transform-origin: 1px;

        ${props =>
            props.$isOpen &&
            `
            &:first-child {
                transform: rotate(45deg);
            }

            &:nth-child(2) {
                opacity: 0;
                transform: translateX(20px);
            }

            &:nth-child(3) {
                transform: rotate(-45deg);
            }
        `}
    }
`;

export const MobileMenu = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: ${props => (props.$isOpen ? "block" : "none")};
        position: absolute;
        top: 80px;
        right: 0;
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        padding: 16px;
        z-index: 1000;
        border: 1px solid #f0f0f0;
        min-width: 200px;
    }
`;

export const MobileAccountSection = styled.div`
    ${MenuButton} {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const StyledSubCompanyInput = styled(Select)`
    .ant-select-selector {
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        padding: 12px 16px !important;
        border: none !important;
        border-radius: 8px !important;
        background-color: #fff !important;
        color: #333 !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        cursor: pointer !important;
        transition: all 0.3s ease !important;
        white-space: nowrap !important;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1) !important;
        border: 1px solid #f0f0f0 !important;
        min-height: 48px !important;
        min-width: 200px !important;
    }

    .ant-select-selector:hover {
        background-color: #f8f8f8 !important;
        transform: translateY(-2px) !important;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15) !important;
    }

    .ant-select-arrow {
        color: #333 !important;
    }

    .ant-select-selection-item {
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #333 !important;
    }

    &.ant-select-focused .ant-select-selector {
        border-color: #aef001 !important;
        box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.2) !important;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        .ant-select-selector {
            min-width: 150px !important;
        }
    }
`;

export const DropdownContainer = styled.div`
    background: white;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 160px;
`;

export const DropdownItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
    background-color: ${props => (props.$isActive ? "#AEF001" : "transparent")};
    color: ${props => (props.$isActive ? "#000" : "#333")};
    font-weight: ${props => (props.$isActive ? "600" : "400")};
    border-bottom: ${props => (props.$hasBorder ? "1px solid #f0f0f0" : "none")};
    transition: all 0.2s ease;

    &:hover {
        background-color: ${props => (props.$isActive ? "#AEF001" : "#AEF001")};
        color: ${props => (props.$isActive ? "#000" : "#000")};
    }

    img {
        width: 16px;
        height: 16px;
    }
`;
